import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { HelpersService } from '../../../../core/services/helpers.service';
import { ModalNotifyService } from "../../../../core/services/modal-notify.service";
import { OperationsService } from '../../../../core/services/operations.service';
import { AnagraficaForm } from '../../../form/anagrafica-form';
import { AnagraficaResponse } from '../../../models/dto/anagrafica-response';
import { Legale } from '../../../models/legale';
import { FormValidationService } from '../../../services/form-validation.service';
import { LegaleAdapter } from '../legali-anagrafica-update/legale-adapter';

declare var closeModal: any;

@Component({
    selector: 'div [legale-anagrafica-form-add]',
  templateUrl: '../../../form/anagrafica-form.html',
})

export class LegaleAnagraficaAddComponent extends AnagraficaForm implements OnInit {
  private urlAggiungiInAnagraficaLegale: string;
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<Legale> = new EventEmitter<Legale>();
  @Input() labelButton: string = 'Inserisci e associa';
  private subscriptionCreate: Subscription;

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService, @Inject(FormValidationService) formValidationService, @Inject(ModalNotifyService) private modalNotifyService) {
        super(operationService, campiForm, helpers, formValidationService);
  }
  ngOnInit() {
    this.isInserimento(true);
  }

  getAdapter(): Legale {
    return new LegaleAdapter(new Legale()).legale;
  }

  private aggiungiAnagrafica(request: Legale, response: boolean) {
    if (response) {
      	this.operationService.addAnagraficaElement(request).subscribe(response => this.legaleCreato(<AnagraficaResponse> response));
    }
    if (this.subscriptionCreate) {
      this.subscriptionCreate.unsubscribe();
    }
  }

  getRequest(request: Legale) {
	if(!request.codiceFiscale && request.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA){
		this.subscriptionCreate = this.modalNotifyService.notifyConfirmObservable.subscribe(result => this.aggiungiAnagrafica(request,result));
		this.modalNotifyService.notifyCustom('ATTENZIONE: La mancata indicazione del Codice Fiscale potrebbe causare problemi di identificazione univoca dell\'anagrafica. Vuoi proseguire? ');
	}else{
		this.operationService.addAnagraficaElement(request).subscribe(response => this.legaleCreato(<AnagraficaResponse> response));
	}
    // this.operationService.addToAnagrafica(this.urlAggiungiInAnagraficaLegale, request).subscribe(response => this.legaleCreato(<LegaleResponse> response));
  }

  legaleCreato(response: AnagraficaResponse) {

    this.onReturn.emit(response.anagrafiche[0] as Legale);
  }

  inizializza(urlAggiungiInAnagraficaLegale: string) {
    this.urlAggiungiInAnagraficaLegale = urlAggiungiInAnagraficaLegale;
    this.populateSelect();
    this.createForm();
  }

  hasConvenzione(): boolean {
      return true;
  }

  hasTariffa(): boolean {
      return true;
  }

  hasDipendete(): boolean {
      return false;
  }

  hasMatricola(): boolean {
    return false;
  }

  hasAmbitiCompetenza(): boolean {
    return true;
  }

  getTipoPratica(){

  }

  ngOnDestroy(): void {
    if (this.subscriptionCreate) {
      this.subscriptionCreate.unsubscribe();
    }
  }
}
